/* src/app/pages/casos/verpaso2/verpaso2.component.scss */
/*# sourceMappingURL=verpaso2.component.css.map */
